import { api } from '@converse/headless';
import { CustomElement } from './element.js';
import { html } from 'lit';
import 'shared/components/logo.js';

export class ConverseBrandLogo extends CustomElement {

    static get properties() {
        return {
            hide_byline: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.hide_byline = false;
    }

    render() {
        const is_fullscreen = api.settings.get('view_mode') === 'fullscreen';
        return html`<a class="brand-heading" href="#" target="_blank" rel="noopener"><span class="brand-name-wrapper ${is_fullscreen ? 'brand-name-wrapper--fullscreen' : ''}"><img src="/static/img/logo.png" alt="پیام‌رسان نور" class="converse-svg-logo"> <span class="brand-name"><span class="brand-name__text">پیام‌رسان نور</span> ${is_fullscreen && !this.hide_byline
                            ? html`<p class="byline">messaging freedom</p>`
                            : ''}</span></span></a>`;
    }
}

api.elements.define('converse-brand-logo', ConverseBrandLogo);
